export default {
  header: 9,
  modal: 12,
  chatOnHover: 10,
};
